import { useState, useRef, useMemo, useEffect } from "react"
import arrayUtilities from "../../utilities/arrayUtilities";
import stringHelpers from "../../utilities/stringHelpers";

export const MultiSearchSelect = ({ unit="options", options, selectedValues, onChange, defaultLabel = "Select options", width, isDisabled = false }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const componentRef = useRef(null);
    const runFilter = () => {
        if (stringHelpers.isNullOrEmpty(searchQuery)) return options;
        return options.filter(option =>
            option.label.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }
    const filteredOptions = useMemo(() => runFilter(), [searchQuery, options]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (componentRef.current && !componentRef.current.contains(event.target)) {
                setSearchQuery('');
                setIsOpen(false);
            }
        };

        const handleKeyPress = (event) => {
            if (event.code === 'Escape') {
                setSearchQuery('');
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keyup', handleKeyPress);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keyup', handleKeyPress);
        };
    }, []);

    const handleToggle = (value) => {
        const current = selectedValues || [];
        const newValues = current.includes(value)
            ? current.filter(v => v !== value)
            : [...current, value];
        onChange(newValues.length > 0 ? newValues : null);
    };

    const close = () => {
        setSearchQuery('');
        setIsOpen(false);
    };

    const selectedCount = selectedValues?.length ?? 0;
    const buttonLabel = selectedCount === 0
        ? defaultLabel
        : selectedCount === 1 ? options.find(item => item.value === selectedValues[0]).label : `${selectedCount} ${unit} selected`;

    return (
        <div className="border rounded position-relative search-select search-select-multi bg-white" ref={componentRef} style={{ width: `${width !== undefined ? width : "100%"}` }}>
            <button
                disabled={isDisabled}
                onClick={() => setIsOpen(!isOpen)}
                className={`btn btn-default d-flex align-items-center w-100 pl-2 pr-0 bg-white py-1 ${isOpen ? "is-open" : ""}`}
            >
                <p className="w-100 text-left m-0 fs--1">{buttonLabel}</p>
                {isOpen ? <i className="fas fa-chevron-up fs--2"></i> : <i className="fas fa-chevron-down fs--2"></i>}
            </button>
            {isOpen && (
                <div className="px-0 border rounded bg-white position-absolute top-100 left-0 search-select-dropdown" style={{ zIndex: 10 }}>
                    <div className="px-1 w-100">
                        <input
                            autoFocus
                            placeholder="Search..."
                            className="form-control my-2 px-2 fs--1 w-100"
                            type="text"
                            value={searchQuery}
                            onChange={e => setSearchQuery(e.target.value)}
                        />
                    </div>
                    {
                        !arrayUtilities.isNullOrEmpty(filteredOptions)
                            ? <ul className="pl-0 w-100 mb-0">
                                {filteredOptions.map((option) => {
                                    const isChecked = (selectedValues || []).includes(option.value);
                                    return (
                                        <li
                                            key={option.value}
                                            onClick={() => handleToggle(option.value)}
                                            className={`dropdown-item cursor-pointer my-1 ml-0 pl-2 fs--1 d-flex align-items-center ${isChecked ? "active" : ""}`}
                                        >
                                            <input
                                                type="checkbox"
                                                readOnly
                                                checked={isChecked}
                                                className="mr-2"
                                                style={{ pointerEvents: "none" }}
                                            />
                                            {option.label}
                                        </li>
                                    );
                                })}
                            </ul>
                            : <p className="py-2 mb-2 fs--1 d-flex justify-content-center">No results found</p>
                    }
                    <div className="p-2 border-top mt-1 bg-white d-flex justify-content-end">
                        <button onClick={() => {
                            setSearchQuery("")
                            onChange(null)
                            runFilter()
                        }} type="button" className="btn btn-falcon-default btn-sm mr-2">
                            Clear
                        </button>
                        <button onClick={close} className="btn btn-primary btn-sm ml-1 nowrap">
                            Done
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
